import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ReplyIcon from '@mui/icons-material/Reply';
import TablePagination from "../../../components/Table/TablePagination";
import EditHelpnSupport from "./EditHelpnSupport";



const HelpAndSupportTable = ({
    setLoading, columns, rows, page, nextId, onNextClick, onPrevClick, rowsPerPage, totalCount, getHelpNSupport
}) => {
    const [openModal, setOpenModal] = useState(false)
    const [rowDetails, setRowDetails] = useState({})

    const replyHandler = (row) => {
        setRowDetails(row.supportData)
        setOpenModal(true)
    }


    const renderContent = (value, rowIndex, row) => {
        if (value === "-") {
            return (
                <ReplyIcon sx={{ color: "blue", cursor: "pointer" }} onClick={() => replyHandler(row)} />
            );
        } else if (typeof value === "number") {
            return ((page - 1) * 10) + rowIndex + 1;
        } else return row.description
    };

    return (
        <div style={{ height: "calc(100% - 61px)" }}>
            {openModal && <EditHelpnSupport open={openModal} setOpen={setOpenModal} isView={true} getHelpNSupport={getHelpNSupport} supportData={rowDetails} />}
            <TableContainer
                sx={{
                    width: "calc(100% - 2px)",
                    borderRadius: "10px",
                    marginTop: "12px",
                    maxHeight: "calc(100% - 68px)",
                    border: "1px solid rgba(224, 224, 224, 1)",
                    overflowY: "auto",
                }}
            >
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>

                        <TableRow sx={{ position: "sticky", zIndex: "1" }}>
                            {columns.map((column, index) => {
                                const textAlignStyle = column.label === "Action" ? "center" : "start";
                                return <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth, textAlign: textAlignStyle }}

                                    sx={{
                                        color: "#323C47",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                    }}
                                >
                                    {column.label}
                                </TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .map((row, rowIndex) => {

                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?._id}>
                                        {columns.map((column, ind) => {
                                            const value = row[column.id];
                                            const pad = value === "-" ? "10px !important" : "auto"
                                            const alignment = value === "-" ? "center" : "start"

                                            return (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    sx={{
                                                        color: "#323C47",
                                                        fontSize: "16px",
                                                        height: "24px",
                                                        padding: pad,
                                                        textAlign: alignment
                                                    }}
                                                >
                                                    {renderContent(value, rowIndex, row)}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            {totalCount > 10 && <TablePagination
                page={page}
                nextId={nextId}
                onNextClick={onNextClick}
                onPrevClick={onPrevClick}
                totalCount={totalCount}
            />}
        </div >
    );
};

export default HelpAndSupportTable;
